<template>
  <div class="custom-targeting-list-table">
    <div v-if="loader && localTargetings.length === 0" class="text-center">
      <Loader
        :size="'big'"
      />
    </div>
    <!-- CARD -->
    <div class="card" :class="openDetail ? 'shadow-none' : ''" v-else>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable">
            <thead v-if="!openDetail">
              <tr>
                <th>{{ $t('name') }}</th>
                <th>{{ $t('type') }}</th>
                <th>{{ $t('elements') }}</th>
                <th>{{ $t('status') }}</th>
                <th>{{ $t('details') }}</th>
              </tr>
            </thead>
            <tbody v-for="(targeting, index) in localTargetings" :key="index">
              <tr
                class="text-nowrap"
                v-if="openedItemId !== targeting.id && !openDetail"
              >
                <td>
                  <a
                    href="#"
                    class="link-color3"
                    @click.prevent="openDetailItem(targeting.id)"
                  >
                    {{ targeting.name }}
                  </a>
                </td>
                <td>{{ targeting.type | formatCustomTargetingType }}</td>
                <td>{{ targeting.value_count }}</td>
                <td>
                  {{ targeting.status | formatStatus }}
                  <template v-if="targeting.status === 'ERROR'">
                    <RetryCustomTargetingCreationOnPlatform
                      :targetingId="targeting.id"
                      @retry-successful="reset"
                      @retry-error="handleRetryError"
                    />
                  </template>
                </td>
                <td>
                  <a
                    href="#"
                    class="link-color2"
                    v-b-tooltip.hover :title="$t('see_more')"
                    @click.prevent="openDetailItem(targeting.id)"
                  >
                    <i class="fa fa-eye"></i>
                  </a>
                </td>
              </tr>
              <CustomTargetingDetail
                :targeting="targeting"
                v-if="openedItemId === targeting.id && openDetail"
              />
            </tbody>
          </table>
        </div>
        <div class="text-center mb-6" v-if="localTargetings.length > 0 && !loader && totalPages > 1 && !openDetail">
          <div class="d-flex flex-stack flex-wrap pt-10">
            <div class="fs-6 fw-semibold text-gray-700">
              {{ $t('pagination', { from: this.from, to: this.to, totalItems: this.total }) }}
            </div>
            <b-pagination
              class="custom-pagination"
              v-model="page"
              :total-rows="total"
              :per-page="itemsPerPage"
              @input="getTargetings"
              hide-goto-end-buttons
            />
          </div>
        </div>
      </div> <!-- END CARD -->
    </div>
  </div>
</template>

<script>

import CustomTargetingsService from '@/modules/custom-targetings/services/custom-targetings-service'

import CustomTargetingDetail from '@/components/custom-targetings/CustomTargetingDetail'
// import CreativeDetailModal from '@/components/creatives/CreativeDetailModal'
import Loader from '@/components/common/Loader/Loader'
import RetryCustomTargetingCreationOnPlatform from '@/components/custom-targetings/RetryCustomTargetingCreationOnPlatform'

export default {
  name: 'CreativeListTable',
  props: ['advertiserId', 'targetings', 'reload', 'types', 'closeStepDetail'],
  components: {
    CustomTargetingDetail,
    // CreativeDetailModal,
    Loader,
    RetryCustomTargetingCreationOnPlatform
  },
  data () {
    return {
      from: 0,
      localTargetings: [],
      loader: false,
      isLoadMoreVisible: true,
      itemsPerPage: 0,
      openDetail: false,
      openedItemId: null,
      page: 1,
      totalPages: 0,
      total: 0,
      to: 0
    }
  },
  created () {
    if (this.targetings) {
      this.localTargetings = this.targetings
      this.isLoadMoreVisible = false
    } else {
      this.getTargetings()
    }
  },
  watch: {
    reload (newValue) {
      if (newValue) this.reset()
    },
    openDetail (newValue) {
      this.$emit('open-step-detail', newValue)
    },
    closeStepDetail (newValue) {
      if (!newValue) {
        this.openedItemId = null
        this.openDetail = newValue
      }
    }
  },
  methods: {
    /**
     * Get targetings
     */
    async getTargetings () {
      if (!this.advertiserId) return false

      this.loader = true
      try {
        this.localTargetings = []
        const targetings = await CustomTargetingsService.getCustomTargetings({
          advertiserId: this.advertiserId,
          types: this.types,
          page: this.page
        })
        this.localTargetings = targetings.data
        this.total = targetings.meta.total
        this.itemsPerPage = targetings.meta.per_page
        this.totalPages = targetings.meta.last_page
        this.to = targetings.meta.to
        this.from = targetings.meta.from
        this.isLoadMoreVisible = targetings.meta.current_page !== targetings.meta.last_page
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    },
    /**
     * Handle retry error
     */
    handleRetryError (error) {
      error.handleGlobally && error.handleGlobally()
    },
    /**
     * Load more
     */
    loadMore () {
      this.page++
      this.getTargetings()
    },
    openDetailItem (id) {
      this.openDetail = true
      this.openedItemId = id
    },
    /**
     * Reset and reload
     */
    reset () {
      this.page = 1
      this.localTargetings = []
      this.getTargetings()
    }
  }
}
</script>
